export const ANCHO_GRANDE = 1942;

export const ANCHO_MOVIL = 960;

export const PROPORCION = 1942 / 809;

export interface ImagenesPreparadas {
  grande: Blob;
  movil: Blob;

  ancho: number;
  alto: number;
}

export async function prepararImagenes(archivo: File): Promise<ImagenesPreparadas> {
  const bitmap = await createImageBitmap(archivo);
  try {
    const [grande, movil] = await Promise.all([
      codificar(bitmap, Math.min(ANCHO_GRANDE, bitmap.width), 0.82),
      codificar(bitmap, Math.min(ANCHO_MOVIL, bitmap.width), 0.8),
    ]);
    return { grande, movil, ancho: bitmap.width, alto: bitmap.height };
  } finally {
    bitmap.close();
  }
}

function codificar(bitmap: ImageBitmap, ancho: number, calidad: number): Promise<Blob> {
  const alto = Math.round((bitmap.height * ancho) / bitmap.width);
  const lienzo = document.createElement('canvas');
  lienzo.width = ancho;
  lienzo.height = alto;
  const contexto = lienzo.getContext('2d');
  if (!contexto) {
    return Promise.reject(new Error('EL NAVEGADOR NO PUEDE PREPARAR LA IMAGEN.'));
  }
  contexto.imageSmoothingQuality = 'high';
  contexto.drawImage(bitmap, 0, 0, ancho, alto);
  return new Promise((resolver, rechazar) =>
    lienzo.toBlob(
      (blob) => (blob ? resolver(blob) : rechazar(new Error('NO SE PUDO PREPARAR LA IMAGEN.'))),
      'image/webp',
      calidad,
    ),
  );
}

export function avisoDeMedidas(ancho: number, alto: number): string | null {
  if (ancho < ANCHO_MOVIL) {
    return `LA IMAGEN MIDE ${ancho} PX DE ANCHO Y SE VERÁ BORROSA. LO IDEAL ES ${ANCHO_GRANDE} × 809.`;
  }
  const desvio = Math.abs(ancho / alto - PROPORCION) / PROPORCION;
  if (desvio > 0.15) {
    return `LA IMAGEN MIDE ${ancho} × ${alto} Y EL CARRUSEL ES 1942 × 809: SE RECORTARÁ POR LOS BORDES.`;
  }
  return null;
}

export function enPeso(bytes: number): string {
  if (bytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  }
  return `${(bytes / (1024 * 1024)).toLocaleString('es-EC', { maximumFractionDigits: 1 })} MB`;
}
